import type { IconSvgObject } from './types';

const HeartOffIcon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.7997 14.5C21.0808 12.7942 22 10.9546 22 9.19444C22 6.32563 19.8947 4 17 4C15.5 4 14 4.5 12 6.5C11.0765 5.57646 10.2595 4.97277 9.5 4.59046", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 17.5947C15.7619 18.7727 14.5238 19.7692 13.5893 20.4679C12.6399 21.1779 11.3601 21.1779 10.4107 20.4679C7.58942 18.3582 2 13.5351 2 9.19469C2 7.24674 2.97064 5.54922 4.5 4.66016", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default HeartOffIcon;
